import Base from './base'

export default {
  get (id, token) {
    return Base
      .get(`view_shippingaddresses/customerid/${id}`, { headers: {Authorization: `Bearer ${token}`} })
      .then(res => res.data)
  }
}
